<script setup>
import {ref, onMounted} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';
import ReportTable from '@ohrm/oxd/core/components/ReportTable/ReportTable';
import {required} from '@ohrm/core/util/validation/rules';

const isLoading = ref(false);
const rules = ref({
  employees: [required],
});
const filters = ref({
  participants: [
    {
      id: 0,
      label: 'All',
    },
  ],
});
const total = ref(0);
const items = ref([]);
const employees = ref([
  {
    id: 0,
    label: 'All',
  },
]);

const http = new APIService(
  window.appGlobal.baseUrl,
  '/api/v2/training/matrix/get-report',
);

const normalizeIds = () => {
  let normalizedIds = [];
  filters.value.participants.forEach(participant => {
    normalizedIds.push(participant.id);
  });
  return (normalizedIds = normalizedIds.join(','));
};

const onSearch = async () => {
  const normalizedIds = normalizeIds();

  await http
    .request({
      method: 'GET',
      params: {
        participants: normalizedIds,
      },
    })
    .then(response => {
      total.value = response.data.meta.total;
      items.value = response.data.data;
    });
};

const onExport = () => {
  const normalizedIds = normalizeIds();

  const url = `${window.appGlobal.baseUrl}/api/v2/training/matrix/export?participants=${normalizedIds}`;
  window.open(url, '_blank');
};

onMounted(async () => {
  const http = new APIService(window.appGlobal.baseUrl, 'api/v2/pim/employees');
  await http
    .getAll({
      includeEmployees: 'onlyCurrent',
    })
    .then(response => {
      employees.value.push(
        ...response.data.data.map(employee => {
          return {
            id: employee.empNumber,
            label: `${employee.firstName} ${employee.middleName} ${employee.lastName}`,
          };
        }),
      );
    });
});
</script>

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('training.training_matrix_report') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSearch">
        <oxd-form-row>
          <oxd-grid :cols="4" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="filters.participants"
                label="Participants"
                value="Select"
                type="multiselect"
                :options="employees"
                :rules="rules.employees"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            style="margin-right: 10px"
            display-type="secondary"
            :label="$t('admin.export_excel')"
            @click="onExport"
          />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>
